import gql from 'graphql-tag';
import cmsHighSchoolDetails from './cms-highschool-details';

export default gql`
  mutation UpdateHighSchool ($input: updateHighSchoolInput!) {
    updateHighSchool(input: $input) {
      viewer {
        id
        cmsHighSchool {
          id
          ...CMSHighSchoolDetails
        }
      }
    }
  }
  ${cmsHighSchoolDetails}
`;
